export default __webpack_public_path__ + "static/media/Ocean tide primary.052ab5cb.jpg";